import WoWildCraftLog from '../../img/WoWildCraftLogo.png';

function WoWildCraft() {
  return <img src={WoWildCraftLog} alt="World of WildCraft Logo" />;
}

export default WoWildCraft;
